/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable default-param-last   */
import merge from 'deepmerge';

const HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';

export const types = {
  GET_BUSINESS_CONSTANTS: 'CONSTANTS/GET_BUSINESS_CONSTANTS',
  SET_BUSINESS_CONSTANTS: 'CONSTANTS/SET_BUSINESS_CONSTANTS',
  HYDRATE: 'CONSTANTS/HYDRATE',
};

export const actions = {
  getBusinessConstants: ({ path, build }) => ({
    type: types.GET_BUSINESS_CONSTANTS,
    path,
    build,
  }),
  setBusinessConstants: (data) => ({
    type: types.SET_BUSINESS_CONSTANTS,
    data,
  }),
};

export const initialState = {
  data: null,
};

function Constants(state = { ...initialState }, action) {
  switch (action.type) {
    case HYDRATE: {
      const { constants } = action.payload;
      /* neceisto preservar lo que viene del sever excepto los filtros */
      const nextState = merge(state, constants);
      return nextState;
    }
    case types.SET_BUSINESS_CONSTANTS:
      return {
        ...state,
        data: action.data,
      };
    default:
      return { ...state };
  }
}

export default Constants;
